<template>
  <el-form class="partner-label-form">
    <el-form-item :label="$t('Tool.PartnerCategory')">
      <el-select v-model="currentKey">
        <el-option v-for="item in partnerConfigList" :key="item.autoKey" :value="item.autoKey" :label="isZh?item.autoName:item.autoEnglishName" />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-radio-group v-model="currentLabel" @change="labelChange">
        <template v-if="currentKey === 'auto_office'">
          <el-radio label="chineseName" style="margin-right: 15px;">{{ $t('CargoMsg.Cargo_BranchCnName') }}</el-radio>
          <el-radio label="englishName" style="margin-right: 15px;">{{ $t('CargoMsg.Cargo_BranchEnName') }}</el-radio>
          <el-radio label="code">{{ $t('CargoMsg.Cargo_BranchCode') }}</el-radio>
        </template>
        <template v-else-if="currentKey === 'auto_paymentTerm'">
          <el-radio label="code">{{ $t('Tool.Code') }}</el-radio>
          <el-radio label="name">{{ $t('Tool.Name') }}</el-radio>
          <el-radio label="codePlusName">{{ isZh ? '代码+名称' : 'Code + Name' }}</el-radio>
          <el-radio label="localName">{{ $t('CargoMsg.Cargo_LocalizedName') }}</el-radio>
        </template>
        <template v-else>
          <el-radio label="chineseName">{{ $t('Tool.Chinese') }}</el-radio>
          <el-radio label="englishName">{{ $t('Tool.English') }}</el-radio>
          <template v-if="['auto_op','auto_sales','auto_csr'].includes(currentKey)">
            <el-radio label="englishNamePlusChineseName">{{ $t('Tool.EnglishAndChinese') }}</el-radio>
            <el-radio label="chineseNamePlusEnglishName">{{ $t('Tool.ChineseAndEnglish') }}</el-radio>
          </template>
          <template v-else>
            <el-radio label="code">{{ $t('Tool.Code') }}</el-radio>
            <el-radio v-if="!['auto_7','auto_8','auto_railway'].includes(currentKey)" label="shortName">{{ $t('Tool.ShortName') }}</el-radio>
            <el-radio label="sortNamePlusChineseName">{{ $t('Tool.CodeAndChinese') }}</el-radio>
            <el-radio label="sortNamePlusEnglishName">{{ $t('Tool.CodeAndEnglish') }}</el-radio>
            <el-radio v-if="Object.keys(currentOpt).includes('shortNamePlusChineseName')" label="shortNamePlusChineseName">{{ $t('Tool.ShortNameAndChinese') }}</el-radio>
            <template v-if="currentKey === 'auto_accountId'">
              <div style="width: 1px;" />
              <el-radio label="customerSupplierNoChineseName" style="overflow: unset;">{{ $t('Tool.CustomerSupplierNoChinese') }}</el-radio>
            </template>
            <el-tooltip v-if="currentKey === 'auto_6'" :content="$t('Tool.threeCharacterCodeTooltip')" placement="top">
              <el-radio label="threeCharacterCode" style="overflow: unset;">
                {{ $t('Tool.threeCharacterCode') }}
              </el-radio>
            </el-tooltip>
            <el-radio v-if="currentKey === 'auto_0'" label="customerNoChineseName" style="overflow: unset;">{{ $t('Tool.CustomerNoChinese') }}</el-radio>
            <el-radio v-if="['auto_1','auto_2','auto_3','auto_4','auto_9','auto_10','auto_11'].includes(currentKey)" label="supplierNoChineseName" style="overflow: unset;">{{ $t('Tool.SupplierNoChinese') }}</el-radio>
          </template>
        </template>
      </el-radio-group>
    </el-form-item>
    <el-form-item :label="$t('Message.AffiliatedBranchStyle')" class="label-bold" />
    <el-form-item>
      <el-radio-group v-model="ownedBranchStyle">
        <el-radio label="level" style="width: 35%;">{{ $t('Message.DisplayByOrganizationalStructure') }}</el-radio>
        <el-radio label="list">{{ $t('Message.AllDisplay') }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item :label="$t('CargoMsg.Cargo_SOPWorkTaskBoard')" class="label-bold">
      <div style="display: flex;">
        <i class="el-icon-warning" style="color: #E6A23C;line-height: 28px;" />
        <span :title="$t('Message.CloseRefreshNeedMannulUpdate')" style="color: #E6A23C;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ $t('Message.CloseRefreshNeedMannulUpdate') }}</span>
      </div>
    </el-form-item>
    <el-form-item :label="$t('Message.RefreshRule')" label-width="120px" label-position="right" style="margin-top: -10px">
      <div style="display: flex;">
        <el-checkbox v-model="sopWorkTaskBoardSetting.disabledAutoRefresh" />
        <span :title="$t('Message.HomePageNotRefreshData')" style="color: #666666;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;margin-left: 10px;">{{ $t('Message.HomePageNotRefreshData') }}</span>
      </div>
    </el-form-item>
    <el-form-item :label="$t('Message.NodeRecord')" label-width="120px" label-position="right" style="margin-top: -10px">
      <el-checkbox v-model="sopWorkTaskBoardSetting.keepSelectedNode">{{ $t('Message.DisplayLastClickNode') }}</el-checkbox>
    </el-form-item>
    <el-form-item label=" " label-width="120px" style="margin-top: -10px">
      <el-checkbox v-model="sopWorkTaskBoardSetting.keepQueryCondition">{{ $t('Message.RetainQueryCondition') }}</el-checkbox>
    </el-form-item>
    <el-form-item :label="$t('Message.TaskBoard')" label-width="120px" style="margin-top: -10px">
      <el-checkbox v-model="sopWorkTaskBoardSetting.resetQueryOnTemplateSwitch">{{ $t('Message.DoOfQueryResultsTemplates') }}</el-checkbox>
    </el-form-item>
    <el-form-item :label="$t('CargoMsg.Cargo_WarnTodoList')" class="label-bold">
      <div style="display: flex;">
        <i class="el-icon-warning" style="color: #E6A23C;line-height: 28px;" />
        <span :title="$t('Message.CloseRefreshNeedMannulUpdate')" style="color: #E6A23C;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ $t('Message.CloseRefreshNeedMannulUpdate') }}</span>
      </div>
    </el-form-item>
    <el-form-item :label="$t('Message.RefreshRule')" label-width="120px" label-position="right" style="margin-top: -10px">
      <div style="display: flex;">
        <el-checkbox v-model="preWarningSetting.disabledAutoRefresh" />
        <span :title="$t('Message.HomePageNotRefreshData')" style="color: #666666;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;margin-left: 10px;">{{ $t('Message.HomePageNotRefreshData') }}</span>
      </div>
    </el-form-item>
    <el-form-item :label="$t('Message.NodeRecord')" label-width="120px" label-position="right" style="margin-top: -10px">
      <el-checkbox v-model="preWarningSetting.keepSelectedNode">{{ $t('Message.DisplayLastClickNode') }}</el-checkbox>
    </el-form-item>
    <el-form-item label=" " label-width="120px" style="margin-top: -10px">
      <el-checkbox v-model="preWarningSetting.keepQueryCondition">{{ $t('Message.RetainQueryCondition') }}</el-checkbox>
    </el-form-item>
    <el-form-item :label="$t('Message.AlertNode')" label-width="120px" style="margin-top: -10px">
      <el-checkbox v-model="preWarningSetting.resetQueryOnTemplateSwitch">{{ $t('Message.DoOfQueryResultsTemplates') }}</el-checkbox>
    </el-form-item>
    <el-form-item :label="$t('CargoMsg.PriorityDisplay')" label-width="120px" class="label-bold">
      <div style="display: flex;">
        <i class="el-icon-warning" style="color: #E6A23C;line-height: 28px;" />
        <span :title="$t('CargoMsg.WhenTheNodeAllDisplayed')" style="color: #E6A23C;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ $t('CargoMsg.WhenTheNodeAllDisplayed') }}</span>
      </div>
    </el-form-item>
    <el-form-item :label="$t('CargoMsg.DefaultDisplay')" label-width="120px" style="margin-top: -10px">
      <cargo-advance-select
        filterable
        :multiple="true"
        :placeholder="$t('CargoMsg.PrioritizationSettings')"
        callback-method-type="value"
        :static-options="PRIORITIES"
        :default-multiple-value="toArray(dataPriorityDisplaySetting.defaultDisplay)"
        tag-name="name"
        tag-value="code"
        style="width: 250px;"
        @parentCallBack="value=>{dataPriorityDisplaySetting.defaultDisplay=toTxt(value)}"
      />
    </el-form-item>
    <el-form-item class="save-btn">
      <el-button type="primary" @click="handleSave">{{ $t('Tool.Save') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import { getPersonQueryConfig, savePersonQueryConfig } from '@/api/commonComponent'
import { getLoading } from '@/utils/utilBaseElement'
import lodash from 'lodash'
import store from '@/store'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'PartnerLabelSetting',
  components: { CargoAdvanceSelect },
  data() {
    return {
      PRIORITIES: [
        { code: '3', name: this.$t('CargoMsg.Cargo_PriorityHigh') },
        { code: '2', name: this.$t('CargoMsg.Cargo_PriorityMedium') },
        { code: '1', name: this.$t('CargoMsg.Cargo_PriorityLow') }
      ],
      currentKey: 'auto_0',
      currentLabel: '',
      loading: null,
      ownedBranchStyle: this.$store.state.settings.ownedBranchStyle,
      sopWorkTaskBoardSetting: { // sop工作任务看板设置
        disabledAutoRefresh: false, // 是否禁用自动刷新
        keepSelectedNode: false, // 是否保持选中节点
        keepQueryCondition: false, // 是否保持查询条件
        resetQueryOnTemplateSwitch: false // 不根据查询结果数量显示，切换模板时重置查询条件
      },
      preWarningSetting: { // 预警待办事项列表设置
        disabledAutoRefresh: false, // 是否禁用自动刷新
        keepSelectedNode: false, // 是否保持选中节点
        keepQueryCondition: false, // 是否保持查询条件
        resetQueryOnTemplateSwitch: false // 不根据查询结果数量显示，切换模板时重置查询条件
      },
      dataPriorityDisplaySetting: { // 数据优先级显示设置
        defaultDisplay: '' // 默认显示
      }
    }
  },
  computed: {
    partnerConfigList() {
      return lodash.cloneDeep(this.$store.state.settings.partnerLabelSettings)
    },
    currentOpt() {
      return this.partnerConfigList.find(item => item.autoKey === this.currentKey)
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    currentKey(e) {
      this.currentKeyChange(e)
    }
  },
  created() {
    this.currentKeyChange()
    const sopWorkTaskBoardSetting = LocalStorageUtilsNew.getConfiguration('sopWorkTaskBoard-setting')
    if (sopWorkTaskBoardSetting) {
      Object.assign(this.sopWorkTaskBoardSetting, sopWorkTaskBoardSetting)
    }
    const preWarningSetting = LocalStorageUtilsNew.getConfiguration('preWarning-setting')
    if (preWarningSetting) {
      Object.assign(this.preWarningSetting, preWarningSetting)
    }
    const dataPriorityDisplaySetting = LocalStorageUtilsNew.getConfiguration('dataPriorityDisplay-setting')
    if (dataPriorityDisplaySetting) {
      Object.assign(this.dataPriorityDisplaySetting, dataPriorityDisplaySetting)
    }
  },
  methods: {
    currentKeyChange(e) {
      const currentKey = e || this.currentKey
      const currentOpt = this.partnerConfigList.find(item => item.autoKey === currentKey)
      const keys = Object.keys(currentOpt)
      keys.forEach(key => {
        if (currentOpt[key] === true) {
          this.currentLabel = key
        }
      })
    },
    labelChange(e) {
      console.log(e)
      const currentKey = this.currentKey
      const currentOpt = this.partnerConfigList.find(item => item.autoKey === currentKey)
      const keys = Object.keys(currentOpt)
      keys.forEach(key => {
        if (currentOpt[key] === true) {
          currentOpt[key] = false
        }
      })
      this.$nextTick(() => {
        currentOpt[e] = true
      })
    },
    handleSave() {
      this.loading = getLoading('partner-label-form')
      console.log(this.partnerConfigList)
      const currentUserInfo = getUserInfo()
      const data = {
        bDefault: true,
        configModule: '10086',
        configName: `local_uiDoc_person_partnerLabel_${currentUserInfo.tenantId}_${currentUserInfo.userId}_10086`,
        configType: 3, // 固定值，表格配置
        configContent: JSON.stringify(this.partnerConfigList)
      }
      this.$store.dispatch('settings/changeSetting', { key: 'partnerLabelSettings', value: this.partnerConfigList })
      this.$store.dispatch('settings/setOwnedBranchStyle', this.ownedBranchStyle)
      LocalStorageUtilsNew.setConfiguration('sopWorkTaskBoard-setting', this.sopWorkTaskBoardSetting)
      LocalStorageUtilsNew.setConfiguration('preWarning-setting', this.preWarningSetting)
      LocalStorageUtilsNew.setConfiguration('dataPriorityDisplay-setting', this.dataPriorityDisplaySetting)
      savePersonQueryConfig(data).then(res => {
        this.$message.success(this.$t('Tool.SaveSucceed'))
      }).finally(() => {
        this.loading.close()
      })
    },
    reload() {
      this.loading = getLoading('partner-label-form')
      const currentUserInfo = getUserInfo()
      const data = {
        bDefault: true,
        configModule: '10086',
        configName: `local_uiDoc_person_partnerLabel_${currentUserInfo.tenantId}_${currentUserInfo.userId}_10086`,
        configType: 3, // 固定值，表格配置
        configBy: currentUserInfo.userId,
        tenantId: currentUserInfo.tenantId
      }
      getPersonQueryConfig(data).then(res => {
        const { data } = res
        const defaultConfig = data.find(item => item.bDefault)
        if (defaultConfig && defaultConfig.configContent) {
          const cacheConfig = store.state.settings.partnerLabelSettings
          const remoteConfigs = JSON.parse(defaultConfig.configContent)
          console.log('settings/changeSettingremoteConfig', remoteConfigs)
          const configMerged = cacheConfig.reduce((result, config) => {
            const newConfig = { ...config }
            Object.keys(newConfig).forEach(key => {
              const remoteConfig = remoteConfigs.find(conf => conf.autoKey === config.autoKey)
              if (typeof newConfig[key] === 'boolean' && remoteConfig) {
                newConfig[key] = remoteConfig[key] || false
              }
            })
            result.push(newConfig)
            return result
          }, [])
          this.$store.dispatch('settings/changeSetting', { key: 'partnerLabelSettings', value: configMerged })
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    toArray(txt) {
      if (txt) {
        return txt.split(',')
      }
      return []
    },
    toTxt(strs) {
      if (strs && strs.length > 0) {
        return strs.join(',')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.partner-label-form{
  max-width: 450px;
  margin: 0 auto;
  padding: 15px 0 0 0;
  box-sizing: border-box;
  .el-form-item{
    margin-bottom: 15px !important;
    /deep/ .el-form-item__label{
      font-size: 13px;
    }
    &.label-bold {
       /deep/ .el-form-item__label{
        font-weight: bold;
      }
    }
    .el-radio-group{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      .el-radio{
        width: 25%;
        margin: 0 0 15px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        /deep/ .el-radio__label{
          font-size: 13px;
        }
      }
    }
    .el-checkbox {
      /deep/ .el-checkbox__label {
        color: #666666;
      }
    }
    &.save-btn{
      text-align: center;
      /deep/ .el-button{
        width: 120px;
        background-color: #409EFF;
        border-color: #409EFF;
      }
    }
  }
}
</style>
